__turbopack_context__.v({
  "card": "Features-module__399mxa__card",
  "content": "Features-module__399mxa__content",
  "contentWrapper": "Features-module__399mxa__contentWrapper",
  "icon": "Features-module__399mxa__icon",
  "image": "Features-module__399mxa__image",
  "learnMore": "Features-module__399mxa__learnMore",
  "preview": "Features-module__399mxa__preview",
  "previewList": "Features-module__399mxa__previewList",
  "previewTrigger": "Features-module__399mxa__previewTrigger",
  "title": "Features-module__399mxa__title",
});
